'use client'

import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Logo from '@repo/shared-core-ui-components/logos/main-logo/MainLogoNoText'
import { AuroraBackground } from '@repo/shared-core-ui-components/StyleHelpers/AuroraBackground'
import { useResponsive } from '@repo/shared-theme-utils/hooks/useResponsive'
import { LoginForm } from '@repo/shared-account-auth-feature/login-form/LoginForm'

export function LoginView() {
  const smUp = useResponsive('up', 'sm')

  return (
    <>
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
              <Stack sx={{ flexGrow: 1, textAlign: 'center', alignItems: 'center' }} spacing={2}>
                <Logo sx={{ height: 256, width: 256 }} />
                <Typography variant="h4" gutterBottom>
                  Sign in to AdexTrading
                </Typography>
              </Stack>
            </Stack>

            <AuroraBackground />
            <LoginForm />
          </ContentStyle>
        </Container>
      </RootStyle>
    </>
  )
}

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(4, 0)
}))
